import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import { CalendarSummaryItemCalendarSummaryFragmentDoc } from './CalendarSummaryItem.generated';
import { SearchCalendarSummaryFunctionCalendarSummaryFragmentDoc } from './search.generated';
import { SortCalendarSummaryFunctionCalendarSummaryFragmentDoc } from './sort.generated';
export type CalendarSummaryViewCalendarSummaryFragment = { __typename?: 'CalendarSummary', guid: string, status: Types.CalendarStatus, publicTitle: string, privateTitle?: string | null, description?: string | null, createdAt: TimeString, assignedStaffs: Array<{ __typename?: 'CalendarAssignedStaff', displayName: string, guid: string, priority?: number | null }> };

export const CalendarSummaryViewCalendarSummaryFragmentDoc = gql`
    fragment CalendarSummaryViewCalendarSummary on CalendarSummary {
  guid
  ...CalendarSummaryItemCalendarSummary
  ...SearchCalendarSummaryFunctionCalendarSummary
  ...SortCalendarSummaryFunctionCalendarSummary
}
    ${CalendarSummaryItemCalendarSummaryFragmentDoc}
${SearchCalendarSummaryFunctionCalendarSummaryFragmentDoc}
${SortCalendarSummaryFunctionCalendarSummaryFragmentDoc}`;